import { Clock } from "lucide-react";

export default function PublicLeadPaused({ form }) {
  const color = form?.primary_color || "#10b981";

  return (
    <div className="min-h-screen bg-gray-50 py-8 px-4 sm:py-12">
      <div className="max-w-md mx-auto">
        <div className="bg-white rounded-2xl shadow-sm overflow-hidden animate-fade-in">
          <div className="h-2" style={{ backgroundColor: color }} />

          <div className="p-6 sm:p-8 text-center">
            {form?.logo_url && (
              <img
                src={form.logo_url}
                alt=""
                className="h-12 mb-5 object-contain mx-auto"
              />
            )}

            <div
              className="w-14 h-14 rounded-full flex items-center justify-center mx-auto mb-4"
              style={{ backgroundColor: `${color}15` }}
            >
              <Clock size={26} style={{ color }} />
            </div>

            <h1 className="text-xl sm:text-2xl font-semibold text-gray-900 mb-2">
              Ahora mismo no podemos acoger más personas
            </h1>
            <p className="text-sm text-gray-600 leading-relaxed">
              Estamos al completo y hemos pausado las nuevas solicitudes
              temporalmente. Vuelve a intentarlo en unos días, ¡gracias por tu
              interés!
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}
